import { NpiDestinationEnum, NpiSourceEnum } from '../dto/recs.dto';

export class Npi {
  private encryptedNumber?: string;
  private source?: NpiSourceEnum;
  private destination: NpiDestinationEnum = NpiDestinationEnum.GENERAL;

  public getEncryptedNumber (): string | null {
    return this.encryptedNumber ?? null;
  }

  public setEncryptedNumber (encryptedNumber: string): this {
    this.encryptedNumber = encryptedNumber;

    return this;
  }

  public getSource (): NpiSourceEnum | null {
    return this.source ?? null;
  }

  public setSource (source: NpiSourceEnum): this {
    this.source = source;

    return this;
  }

  public getDestination (): NpiDestinationEnum {
    return this.destination;
  }

  public setDestination (destination: NpiDestinationEnum): this {
    this.destination = destination;

    return this;
  }
}
